<template>
  <div class="podcastArea">
    <div v-if="podcastIframe" @click="togglePodcastPlayer" class="podcastTiitle">
      <v-icon>mdi-chevron-down</v-icon> <span>{{ podcastTitle }}</span>
    </div>
    <div v-html="podcastIframe"></div>
  </div>
  <div @click="togglePodcastPlayer" v-if="viewPodcastOpenIcon" class="podcast-open-icon">
    <v-icon>mdi-podcast</v-icon>
  </div>
</template>

<script>
export default {
  name: 'PodcastPlayer',
  data: () => ({
    viewPodcastOpenIcon: false
  }),
  props: {
    podcastIframe: {
      type: String,
      default: ''
    },
    podcastTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    togglePodcastPlayer() {
      if (document.querySelector('.podcastArea').classList.contains('open')) {
        document.querySelector('.podcastArea').classList.remove('open');
        this.viewPodcastOpenIcon = true;
      } else {
        document.querySelector('.podcastArea').classList.add('open');
        this.viewPodcastOpenIcon = false;
      }
    }
  },
  watch: {
    podcastIframe: function() {
      this.viewPodcastOpenIcon = false;
    }
  }
}
</script>

<style scoped>
.podcastArea {
  bottom: -700px;
  position: fixed;
  width: 100%;
  background: #fff;
  padding: 15px;
  z-index: 1003;
  border-top: 1px solid #ddd;
  transition: bottom 0.3s ease-in-out;
  background-color: #dce6f2;
}

.podcastArea.open {
  bottom: 72px;
}

.podcastTiitle {
  text-align: center;
  margin-bottom: 10px;
  overflow: hidden;
  height: 26px;
  display: flex;
}

.closeButton {
  text-align: center;
  padding: 5px;
  margin-bottom: 10px;
}

.podcast-open-icon {
  position: fixed;
  bottom: 85px;
  left: 10px;
  z-index: 1015;
  font-size: 40px;
  widows: 60px;
  height: 60px;
  color: #fff;
  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.8));
  opacity: 0.4;
}</style>